import { Button } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const BackButton = ({ route }: { route: string }) => {
  const router = useRouter()
  const { t } = useTranslation('common')

  return (
    <Button
      variant="subtle"
      color="#15aabf"
      onClick={() => router.push(route)}
      leftIcon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="#15aabf"
          className="size-6"
          width={18}
          height={18}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3"
          />
        </svg>
      }
    >
      {t('goBack')}
    </Button>
  )
}

export default BackButton
